import { render, staticRenderFns } from "./searchDynamic.vue?vue&type=template&id=55650329"
import script from "./searchDynamic.vue?vue&type=script&lang=js"
export * from "./searchDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports